var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatricLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 9,
    viewBox: "0 0 52 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_326_151",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 0H0V9H52V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_326_151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94711 5.48385C6.89778 4.41769 6.83845 3.1263 6.84822 2.00891H6.81867C6.55178 3.01345 6.22578 4.13084 5.87 5.17624L4.71378 8.76403H3.57733L2.51 5.22771C2.20378 4.1717 1.91711 3.04415 1.69978 2.00891H1.68C1.65022 3.08522 1.60089 4.39739 1.54156 5.53509L1.36378 8.86648H0L0.533556 0.584137H2.45067L3.49822 3.91554C3.78489 4.88938 4.032 5.87339 4.22955 6.79602H4.26911C4.48644 5.89393 4.75333 4.87901 5.05956 3.90515L6.16644 0.584137H8.06378L8.52822 8.86648H7.09533L6.94711 5.48385Z",
    fill: "url(#paint0_linear_326_151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0387 6.29398C11.0783 7.38044 11.8887 7.84176 12.8176 7.84176C13.4896 7.84176 13.9836 7.73929 14.4185 7.57522L14.6359 8.62084C14.1419 8.82576 13.4501 8.98984 12.6199 8.98984C10.7523 8.98984 9.64545 7.80091 9.64545 5.96605C9.64545 4.30543 10.6139 2.74727 12.4619 2.74727C14.3296 2.74727 14.9521 4.34627 14.9521 5.65843C14.9521 5.94551 14.9323 6.1606 14.9027 6.29398H11.0387ZM13.5785 5.2382C13.5883 4.68458 13.3512 3.77235 12.3827 3.77235C11.4834 3.77235 11.0981 4.6232 11.0387 5.2382H13.5785Z",
    fill: "url(#paint1_linear_326_151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.798 1.1683V2.88017H19.1816V4.0077H17.798V6.65233C17.798 7.38019 17.9858 7.75934 18.5491 7.75934C18.796 7.75934 18.9838 7.71826 19.1223 7.68757L19.142 8.84604C18.9245 8.92797 18.5491 8.98935 18.0847 8.98935C17.5509 8.98935 17.0965 8.80496 16.8296 8.49735C16.5231 8.14888 16.3749 7.6158 16.3749 6.82657V4.0077H15.5449V2.88017H16.3749V1.52692L17.798 1.1683Z",
    fill: "url(#paint2_linear_326_151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2886 4.80759C20.2886 3.99781 20.2788 3.4135 20.2393 2.88042H21.5041L21.5535 4.02851H21.603C21.8895 3.17788 22.5617 2.74727 23.1744 2.74727C23.3126 2.74727 23.4017 2.75742 23.5201 2.78834V4.20297C23.4017 4.18243 23.273 4.1515 23.0953 4.1515C22.3937 4.1515 21.9193 4.6232 21.7906 5.29958C21.771 5.43297 21.7413 5.59682 21.7413 5.77128V8.86684H20.2886V4.80759Z",
    fill: "url(#paint3_linear_326_151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0582 1.20956C26.0582 1.66071 25.7422 2.01956 25.2282 2.01956C24.744 2.01956 24.418 1.66071 24.418 1.20956C24.418 0.738094 24.744 0.38963 25.2382 0.38963C25.742 0.379476 26.0482 0.738094 26.0582 1.20956ZM24.5069 8.86676V2.88057H25.9791V8.86676H24.5069Z",
    fill: "url(#paint4_linear_326_151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7907 8.68245C31.4845 8.82576 30.8816 8.98984 30.1502 8.98984C28.3518 8.98984 27.1758 7.80091 27.1758 5.94551C27.1758 4.1515 28.3616 2.74727 30.3876 2.74727C30.9211 2.74727 31.4646 2.87026 31.8006 3.03434L31.5438 4.16189C31.3064 4.04904 30.9606 3.92604 30.4368 3.92604C29.3201 3.92604 28.6579 4.77689 28.6679 5.86337C28.6679 7.0936 29.4388 7.79052 30.4368 7.79052C30.9506 7.79052 31.3063 7.67791 31.583 7.55468L31.7907 8.68245Z",
    fill: "url(#paint5_linear_326_151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3892 0.573959V8.85654H32.9268V0.573959H34.3892Z",
    fill: "url(#paint6_linear_326_151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0698 4.66405C36.0698 3.97727 36.0601 3.39297 36.0205 2.88042H37.3052L37.3743 3.7825H37.4138C37.661 3.31103 38.2934 2.74727 39.2518 2.74727C40.2598 2.74727 41.3074 3.42388 41.3074 5.32012V8.87722H39.845V5.49436C39.845 4.63335 39.5385 3.97727 38.7381 3.97727C38.155 3.97727 37.7498 4.40789 37.6016 4.85882C37.5523 4.99221 37.5423 5.17659 37.5423 5.35082V8.86684H36.0698V4.66405Z",
    fill: "url(#paint7_linear_326_151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0698 4.66405C36.0698 3.97727 36.0601 3.39297 36.0205 2.88042H37.3052L37.3743 3.7825H37.4138C37.661 3.31103 38.2934 2.74727 39.2518 2.74727C40.2598 2.74727 41.3074 3.42388 41.3074 5.32012V8.87722H39.845V5.49436C39.845 4.63335 39.5385 3.97727 38.7381 3.97727C38.155 3.97727 37.7498 4.40789 37.6016 4.85882C37.5523 4.99221 37.5423 5.17659 37.5423 5.35082V8.86684H36.0698V4.66405Z",
    fill: "url(#paint8_linear_326_151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0162 8.86666V4.00802H42.2354V2.88048H43.0162V2.61394C43.0162 1.83486 43.2138 1.06616 43.7178 0.573929C44.1427 0.164081 44.7258 0 45.2298 0C45.6251 0 45.9314 0.061615 46.1685 0.143539L46.05 1.31217C45.8918 1.25054 45.6942 1.19932 45.4373 1.19932C44.7158 1.20947 44.4689 1.83486 44.4689 2.57286V2.88048H45.7338V4.00802H44.4787V8.86666H43.0162Z",
    fill: "url(#paint9_linear_326_151)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9995 5.81219C51.9995 8.01628 50.5075 9.00028 49.0351 9.00028C47.4044 9.00028 46.1395 7.83166 46.1395 5.91488C46.1395 3.94664 47.3847 2.74733 49.124 2.74733C50.8433 2.73717 51.9995 3.99787 51.9995 5.81219ZM47.6415 5.8738C47.6415 7.03204 48.1851 7.90343 49.0744 7.90343C49.9047 7.90343 50.4878 7.05257 50.4878 5.85326C50.4878 4.92049 50.0824 3.84418 49.0844 3.84418C48.0567 3.84418 47.6415 4.87942 47.6415 5.8738Z",
    fill: "url(#paint10_linear_326_151)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_326_151",
    x1: 5.14126,
    y1: 2.63571,
    x2: 4.19802,
    y2: 8.85646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#612FB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#5628A7",
    stopOpacity: 0.993196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#5628A7",
    stopOpacity: 0.989612
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0003,
    stopColor: "#5628A7",
    stopOpacity: 0.999364
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004,
    stopColor: "#5628A7",
    stopOpacity: 0.999465
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0444807,
    stopColor: "#5628A7",
    stopOpacity: 0.999676
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153762,
    stopColor: "#5628A7",
    stopOpacity: 0.999064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153862,
    stopColor: "#5628A7",
    stopOpacity: 0.999798
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A57F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_326_151",
    x1: 12.2988,
    y1: 2.74727,
    x2: 12.2988,
    y2: 8.98984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0468485,
    stopColor: "#955BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903907,
    stopColor: "#A451E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A350EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#8814EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27C86",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_326_151",
    x1: 17.3632,
    y1: 1.1683,
    x2: 17.3632,
    y2: 8.98935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0468485,
    stopColor: "#955BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.903907,
    stopColor: "#A451E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A350EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#8814EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27C86",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_326_151",
    x1: 21.8797,
    y1: 2.74727,
    x2: 21.8797,
    y2: 8.86684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0468485,
    stopColor: "#8E4AFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627849,
    stopColor: "#A350EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A451E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#8814EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27C86",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_326_151",
    x1: 25.2381,
    y1: 0.38942,
    x2: 25.2381,
    y2: 8.86676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0653153,
    stopColor: "#711EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627849,
    stopColor: "#A350EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690352,
    stopColor: "#8814EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#A451E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27C86",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_326_151",
    x1: 29.4882,
    y1: 2.74727,
    x2: 29.4882,
    y2: 8.98984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD5DEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0468485,
    stopColor: "#955BF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0913585,
    stopColor: "#A350EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971619,
    stopColor: "#8814EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E27C86",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_326_151",
    x1: 33.658,
    y1: 0.573959,
    x2: 33.658,
    y2: 8.85654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8814EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#975AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0468485,
    stopColor: "#955CF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836194,
    stopColor: "#A451E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9997,
    stopColor: "#A350EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#E27C86",
    stopOpacity: 0.82
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_326_151",
    x1: 38.664,
    y1: 2.74727,
    x2: 38.664,
    y2: 8.87722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0312226,
    stopColor: "#A04FEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973987,
    stopColor: "#F07B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_326_151",
    x1: 38.664,
    y1: 2.74727,
    x2: 38.664,
    y2: 8.87722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D3FF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0757326,
    stopColor: "#A250EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.153862,
    stopColor: "#A451EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356999,
    stopColor: "#A652E7",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07B91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_326_151",
    x1: -0.16264,
    y1: 4.43195,
    x2: 51.2971,
    y2: 4.43195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_326_151",
    x1: -0.162002,
    y1: 5.8708,
    x2: 51.2978,
    y2: 5.8708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#542E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0674,
    stopColor: "#563292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1399,
    stopColor: "#5D3F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2146,
    stopColor: "#6755A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2685,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2876,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401042,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5197,
    stopColor: "#7169AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588542,
    stopColor: "#7764AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7266,
    stopColor: "#845BA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F38280"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatricLogo);
export default __webpack_public_path__ + "static/media/MatricLogo.69efa40451baaec6022078c03b35ebcd.svg";
export { ForwardRef as ReactComponent };